// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file gitpod/v1/agent.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateAgentExecutionConversationTokenRequest, CreateAgentExecutionConversationTokenResponse, CreateAgentRequest, CreateAgentResponse, CreateLLMAccessTokenRequest, CreateLLMAccessTokenResponse, CreateMCPAccessTokenRequest, CreateMCPAccessTokenResponse, CreatePromptRequest, CreatePromptResponse, DeleteAgentExecutionRequest, DeleteAgentExecutionResponse, DeleteAgentRequest, DeleteAgentResponse, DeletePromptRequest, DeletePromptResponse, GetAgentExecutionRequest, GetAgentExecutionResponse, GetAgentRequest, GetAgentResponse, GetPromptRequest, GetPromptResponse, ImprovePromptForAgentRequest, ImprovePromptForAgentResponse, ListAgentExecutionsRequest, ListAgentExecutionsResponse, ListAgentsRequest, ListAgentsResponse, ListMCPIntegrationsRequest, ListMCPIntegrationsResponse, ListPromptsRequest, ListPromptsResponse, SendToAgentExecutionRequest, SendToAgentExecutionResponse, StartAgentRequest, StartAgentResponse, StopAgentExecutionRequest, StopAgentExecutionResponse, UpdateAgentRequest, UpdateAgentResponse, UpdatePromptRequest, UpdatePromptResponse } from "./agent_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service gitpod.v1.AgentService
 */
export const AgentService = {
  typeName: "gitpod.v1.AgentService",
  methods: {
    /**
     * Lists all agents matching the specified criteria.
     *
     * Use this method to find and monitor agents across your organization.
     * Results are ordered by their creation time with the newest first.
     *
     * ### Examples
     *
     * - List all agents:
     *
     *   Retrieves all agents with pagination.
     *
     *   ```yaml
     *   pagination:
     *     pageSize: 10
     *   ```
     *
     * @generated from rpc gitpod.v1.AgentService.ListAgents
     */
    listAgents: {
      name: "ListAgents",
      I: ListAgentsRequest,
      O: ListAgentsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets details about a specific agent including description,
     * and required models.
     *
     * Use this method to:
     * - Check if an agent is defined correctly
     * - Understand which models are required for this agent
     *
     * ### Examples
     *
     * - Get agent details:
     *
     *   ```yaml
     *   agentId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   ```
     *
     * @generated from rpc gitpod.v1.AgentService.GetAgent
     */
    getAgent: {
      name: "GetAgent",
      I: GetAgentRequest,
      O: GetAgentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates a new agent.
     *
     * Use this method to:
     * - Define new agents with custom prompts and tools
     *
     * @generated from rpc gitpod.v1.AgentService.CreateAgent
     */
    createAgent: {
      name: "CreateAgent",
      I: CreateAgentRequest,
      O: CreateAgentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates an existing agent.
     *
     * Use this method to:
     * - Modify agent configuration
     * - Update prompts or required tools
     *
     * @generated from rpc gitpod.v1.AgentService.UpdateAgent
     */
    updateAgent: {
      name: "UpdateAgent",
      I: UpdateAgentRequest,
      O: UpdateAgentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes an agent.
     *
     * Use this method to:
     * - Remove custom agents
     *
     * @generated from rpc gitpod.v1.AgentService.DeleteAgent
     */
    deleteAgent: {
      name: "DeleteAgent",
      I: DeleteAgentRequest,
      O: DeleteAgentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Starts (or triggers) an agent run using a provided agent.
     *
     * Use this method to:
     * - Launch an agent based on a known agent
     *
     * ### Examples
     *
     * - Start an agent with a project ID:
     *
     *   ```yaml
     *   agentId: "b8a64cfa-43e2-4b9d-9fb3-07edc63f5971"
     *   codeContext:
     *     projectId: "2d22e4eb-31da-467f-882c-27e21550992f"
     *   ```
     *
     * @generated from rpc gitpod.v1.AgentService.StartAgent
     */
    startAgent: {
      name: "StartAgent",
      I: StartAgentRequest,
      O: StartAgentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists all agent runs matching the specified filter.
     *
     * Use this method to track multiple agent runs and their associated resources. Results are ordered by their creation time with the newest first.
     *
     * ### Examples
     *
     * - List agent runs by agent ID:
     *
     *   ```yaml
     *   filter:
     *     agentIds: ["b8a64cfa-43e2-4b9d-9fb3-07edc63f5971"]
     *   pagination:
     *     pageSize: 10
     *   ```
     *
     * @generated from rpc gitpod.v1.AgentService.ListAgentExecutions
     */
    listAgentExecutions: {
      name: "ListAgentExecutions",
      I: ListAgentExecutionsRequest,
      O: ListAgentExecutionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets details about a specific agent run, including its metadata, specification,
     * and status (phase, error messages, and usage statistics).
     *
     * Use this method to:
     * - Monitor the run's progress
     * - Retrieve the agent's conversation URL
     * - Check if an agent run is actively producing output
     *
     * ### Examples
     *
     * - Get agent run details by ID:
     *
     *   ```yaml
     *   agentExecutionId: "6fa1a3c7-fbb7-49d1-ba56-1890dc7c4c35"
     *   ```
     *
     * @generated from rpc gitpod.v1.AgentService.GetAgentExecution
     */
    getAgentExecution: {
      name: "GetAgentExecution",
      I: GetAgentExecutionRequest,
      O: GetAgentExecutionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes an agent run.
     *
     * Use this method to:
     * - Clean up agent runs that are no longer needed
     *
     * ### Examples
     *
     * - Delete an agent run by ID:
     *
     *   ```yaml
     *   agentExecutionId: "6fa1a3c7-fbb7-49d1-ba56-1890dc7c4c35"
     *   ```
     *
     * @generated from rpc gitpod.v1.AgentService.DeleteAgentExecution
     */
    deleteAgentExecution: {
      name: "DeleteAgentExecution",
      I: DeleteAgentExecutionRequest,
      O: DeleteAgentExecutionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Sends user input to an active agent run.
     *
     * This method is used to provide interactive or conversation-based input
     * to an agent. The agent can respond with output blocks containing
     * text, file changes, or tool usage requests.
     *
     * ### Examples
     *
     * - Send a text message to an agent:
     *
     *   ```yaml
     *   agentExecutionId: "6fa1a3c7-fbb7-49d1-ba56-1890dc7c4c35"
     *   userInput:
     *     text:
     *       content: "Generate a report based on the latest logs."
     *   ```
     *
     * @generated from rpc gitpod.v1.AgentService.SendToAgentExecution
     */
    sendToAgentExecution: {
      name: "SendToAgentExecution",
      I: SendToAgentExecutionRequest,
      O: SendToAgentExecutionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates a token for conversation access with a specific agent run.
     *
     * This method generates a temporary token that can be used to securely
     * connect to an ongoing agent conversation, for example in a web UI.
     *
     * ### Examples
     *
     * - Create a token to join an agent run conversation in a front-end application:
     *
     *   ```yaml
     *   agentExecutionId: "6fa1a3c7-fbb7-49d1-ba56-1890dc7c4c35"
     *   ```
     *
     * @generated from rpc gitpod.v1.AgentService.CreateAgentExecutionConversationToken
     */
    createAgentExecutionConversationToken: {
      name: "CreateAgentExecutionConversationToken",
      I: CreateAgentExecutionConversationTokenRequest,
      O: CreateAgentExecutionConversationTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Stops an active agent execution.
     *
     * Use this method to:
     * - Stop an agent that is currently running
     * - Prevent further processing or resource usage
     *
     * ### Examples
     *
     * - Stop an agent execution by ID:
     *
     *   ```yaml
     *   agentExecutionId: "6fa1a3c7-fbb7-49d1-ba56-1890dc7c4c35"
     *   ```
     *
     * @generated from rpc gitpod.v1.AgentService.StopAgentExecution
     */
    stopAgentExecution: {
      name: "StopAgentExecution",
      I: StopAgentExecutionRequest,
      O: StopAgentExecutionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Improves an agent's prompt.
     *
     * Use this method to:
     * - Enhance the agent's understanding of the user's request
     * - Refine the agent's response to be more accurate and relevant
     *
     * @generated from rpc gitpod.v1.AgentService.ImprovePromptForAgent
     */
    improvePromptForAgent: {
      name: "ImprovePromptForAgent",
      I: ImprovePromptForAgentRequest,
      O: ImprovePromptForAgentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates a token for LLM access with a specific agent run.
     *
     *
     * @generated from rpc gitpod.v1.AgentService.CreateLLMAccessToken
     */
    createLLMAccessToken: {
      name: "CreateLLMAccessToken",
      I: CreateLLMAccessTokenRequest,
      O: CreateLLMAccessTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists all MCP integrations.
     *
     * Use this method to retrieve all configured MCP integrations.
     *
     * ### Examples
     *
     * - List all MCP integrations:
     *
     *   ```yaml
     *   pagination:
     *     pageSize: 10
     *   ```
     *
     * @generated from rpc gitpod.v1.AgentService.ListMCPIntegrations
     */
    listMCPIntegrations: {
      name: "ListMCPIntegrations",
      I: ListMCPIntegrationsRequest,
      O: ListMCPIntegrationsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates a token for MCP access.
     *
     * Use this method to generate an access token for MCP integrations.
     *
     * @generated from rpc gitpod.v1.AgentService.CreateMCPAccessToken
     */
    createMCPAccessToken: {
      name: "CreateMCPAccessToken",
      I: CreateMCPAccessTokenRequest,
      O: CreateMCPAccessTokenResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists all prompts matching the specified criteria.
     *
     * Use this method to find and browse prompts across your organization.
     * Results are ordered by their creation time with the newest first.
     *
     * ### Examples
     *
     * - List all prompts:
     *
     *   Retrieves all prompts with pagination.
     *
     *   ```yaml
     *   pagination:
     *     pageSize: 10
     *   ```
     *
     * @generated from rpc gitpod.v1.AgentService.ListPrompts
     */
    listPrompts: {
      name: "ListPrompts",
      I: ListPromptsRequest,
      O: ListPromptsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets details about a specific prompt including name, description,
     * and prompt content.
     *
     * Use this method to:
     * - Retrieve prompt details for editing
     * - Get prompt content for execution
     *
     * ### Examples
     *
     * - Get prompt details:
     *
     *   ```yaml
     *   promptId: "07e03a28-65a5-4d98-b532-8ea67b188048"
     *   ```
     *
     * @generated from rpc gitpod.v1.AgentService.GetPrompt
     */
    getPrompt: {
      name: "GetPrompt",
      I: GetPromptRequest,
      O: GetPromptResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates a new prompt.
     *
     * Use this method to:
     * - Define new prompts for templates or commands
     * - Set up organization-wide prompt libraries
     *
     * @generated from rpc gitpod.v1.AgentService.CreatePrompt
     */
    createPrompt: {
      name: "CreatePrompt",
      I: CreatePromptRequest,
      O: CreatePromptResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates an existing prompt.
     *
     * Use this method to:
     * - Modify prompt content or metadata
     * - Change prompt type (template/command)
     *
     * @generated from rpc gitpod.v1.AgentService.UpdatePrompt
     */
    updatePrompt: {
      name: "UpdatePrompt",
      I: UpdatePromptRequest,
      O: UpdatePromptResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes a prompt.
     *
     * Use this method to:
     * - Remove unused prompts
     *
     * @generated from rpc gitpod.v1.AgentService.DeletePrompt
     */
    deletePrompt: {
      name: "DeletePrompt",
      I: DeletePromptRequest,
      O: DeletePromptResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

